import Vue from "vue";
import Vuetify from "vuetify/lib";
import "@fortawesome/fontawesome-free/css/all.css";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: {
          base: "#FFDE40"
        },
        secondary: {
          base: "#151515"
        },
        accent: {
          base: "#ececec"
        },
        error: {
          base: "#dc3722"
        }
      }
    },
    dark: false
  },
  icons: {
    iconfont: "fa" // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
  }
});
